// cart-lines.js — render items + qty controls (unified via PBCart)
const TRASH_SVG = `
<svg width="16" height="16" viewBox="0 0 24 24" fill="none"
     xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="1.8"
     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
  <path d="M3 6h18" />
  <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  <path d="M19 6l-1.2 13a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8L5 6" />
  <path d="M10 10v7M14 10v7" />
</svg>`;


(function () {
  const drawer = document.getElementById('UnifiedCartDrawer');
  if (!drawer) return;

  const list = document.getElementById('CartLineItems');
  const subtotalEl = document.getElementById('CartSubtotal');

  function log(...a){ try{ console.log('[UCD][lines]', ...a); }catch(e){} }

  function formatEUR(cents) {
    const v = Math.max(0, Number(cents) || 0) / 100;
    try { return new Intl.NumberFormat('nl-NL', { style:'currency', currency:'EUR' }).format(v); }
    catch { return '€' + v.toFixed(2).replace('.', ','); }
  }

  // keep bundle open/closed state across renders
  const bundleOpenByKey = Object.create(null);

  // --- Normalizer: GraphQL cart → /cart.js-like object
  function normalizeCart(gqlCart) {
    const items = (gqlCart.lines?.edges || []).map(e => {
      const n = e.node;
      const merch = n.merchandise;
      const product = merch?.product || {};

      const isBundle = merch?.requiresComponents === true;
      const bundleNodes = merch?.components?.nodes || [];

      const attrs = Object.fromEntries((n.attributes || []).map(a => [a.key, a.value]));

    const before = Math.round(parseFloat(n.cost?.subtotalAmount?.amount || 0) * 100);

    // discount allocations (works for automatic discounts when line totalAmount is buggy)
    const discount = Array.isArray(n.discountAllocations)
      ? n.discountAllocations.reduce((sum, da) => {
          return sum + Math.round(parseFloat(da.discountedAmount?.amount || 0) * 100);
        }, 0)
      : 0;

    const after = Math.max(0, before - discount);

      return {
        key: n.id,
        id: merch?.id,

        product_title: product.title,
        handle: product.handle,

        // parent variant title (optional, usually "Default Title")
        variant_title: merch?.title || '',

        quantity: n.quantity,

      // AFTER discount (computed)
      final_line_price: after,

      // BEFORE discount (for strike)
      original_line_price: before,

        url: `/products/${product.handle || ''}`,
        image: merch?.image?.url,
        properties: attrs,

        isBundle,
        bundleNodes
      };
    });

  const original_total_price = items.reduce((s, it) => s + (Number(it.original_line_price) || 0), 0);

  return {
    items,

    // keep your existing cart total behavior (this is what you already show as €65)
    total_price: Math.round(parseFloat(gqlCart.cost?.subtotalAmount?.amount || 0) * 100),

    // add this for strike in estimated total
    original_total_price
  };
}



  // --- Backend replacements
  function fetchCart() {
    return PBCart.current().then(normalizeCart);
  }

  function changeLine(lineId, quantity) {
    if (quantity <= 0) return PBCart.removeLine(lineId).then(normalizeCart);
    return PBCart.updateLine(lineId, quantity).then(normalizeCart);
  }

  // --- Existing helpers (untouched)
  function withWidthParam(src, w) {
    if (!src) return '';
    const join = src.includes('?') ? '&' : '?';
    return `${src}${join}width=${w}`;
  }

  function isMeaningfulVariantTitle(t) {
    const s = String(t || '').trim();
    if (!s) return false;
    if (s.toLowerCase() === 'default title') return false;
    return true;
  }

  // ✅ Bundle components dropdown (aligned like checkout: image + product + variant)
  function bundleComponentsHTML(lineKey, bundleNodes, parentQty) {
    const nodes = Array.isArray(bundleNodes) ? bundleNodes : [];
    if (!nodes.length) return '';

    const count = nodes.length;
    const isOpen = bundleOpenByKey[lineKey] === true;

    const rows = nodes.map(c => {
      const pv = c?.productVariant || {};
      const qtyEach = Number(c?.quantity || 1);
      const qty = qtyEach * Number(parentQty || 1);

      const productTitle = pv?.product?.title || 'Item';
      const variantTitle = pv?.title || '';
      const showVariant  = isMeaningfulVariantTitle(variantTitle);

      const handle = pv?.product?.handle;
      const href = handle ? `/products/${handle}` : '#';

      const imgSrc = pv?.image?.url ? withWidthParam(pv.image.url, 96) : '';
      const imgAlt = pv?.image?.altText || productTitle;

      // qty + thumb + stacked text
      return `
        <div class="ucd-bundle-row">
          <div class="ucd-bundle-qty">${qty} ×</div>

          <a class="ucd-bundle-thumb" href="${href}" aria-label="${productTitle}">
            ${imgSrc ? `<img class="ucd-bundle-img" src="${imgSrc}" alt="${imgAlt}">` : ''}
          </a>

          <a class="ucd-bundle-link" href="${href}">
            <div class="ucd-bundle-text">
              <div class="ucd-bundle-product">${productTitle}</div>
              ${showVariant ? `<div class="ucd-bundle-variant">${variantTitle}</div>` : ``}
            </div>
          </a>
        </div>
      `;
    }).join('');

    return `
      <div class="ucd-bundle" data-linekey="${lineKey}">
        <button type="button"
          class="ucd-bundle-toggle"
          aria-expanded="${isOpen ? 'true' : 'false'}"
          data-count="${count}">
          <span class="ucd-bundle-toggle__label">${isOpen ? `Hide ${count} items` : `Show ${count} items`}</span>
          <span class="ucd-bundle-toggle__chev" aria-hidden="true">${isOpen ? '▴' : '▾'}</span>
        </button>

        <div class="ucd-bundle-items" style="display:${isOpen ? 'block' : 'none'};">
          ${rows}
        </div>
      </div>
    `;
  }

function lineItemHTML(item) {
  const img = item.image ? withWidthParam(item.image, 240) : '';
  const href = item.url || item.handle ? (`/products/${item.handle || ''}`) : '#';
  const isGift = item.properties && item.properties._auto_gift === 'true';

  // Extract numeric variant ID from GID (e.g. "gid://shopify/ProductVariant/123" → "123")
  const variantId = (item.id || '').split('/').pop();

  let bundleToggleHtml = '';
  let bundleItemsHtml = '';

  if (item.isBundle) {
    const bundleHTML = bundleComponentsHTML(item.key, item.bundleNodes, item.quantity);

    const temp = document.createElement('div');
    temp.innerHTML = bundleHTML;

    const bundle = temp.querySelector('.ucd-bundle');
    const toggle = bundle?.querySelector('.ucd-bundle-toggle');
    const items  = bundle?.querySelector('.ucd-bundle-items');

    if (toggle) bundleToggleHtml = toggle.outerHTML;
    if (items) {
      bundleItemsHtml = `
        <div class="ucd-bundle" data-linekey="${item.key}">
          ${items.outerHTML}
        </div>
      `;
    }
  }

    return `
      <li class="ucd-line" data-key="${item.key}" data-variant-id="${variantId}">
        <div class="ucd-media">
          ${img ? `<a href="${href}" aria-label="View details for ${item.product_title}">
            <img src="${img}" alt="${item.product_title}">
          </a>` : ''}
        </div>

        <div class="ucd-info">
          <a role="heading" aria-level="5" href="${href}" class="ucd-title">
            ${item.product_title}${isGift ? ' <span class="ucd-gift-tag">• Gift</span>' : ''}
          </a>

        <div class="ucd-qty">
          <button aria-label="Decrease quantity of ${item.product_title}" type="button" class="ucd-qty-btn" data-act="dec">−</button>
          <span class="ucd-qty-label">
            <span class="sr-only">Quantity of ${item.product_title}</span>
            <span class="ucd-qty-num">${item.quantity}</span>
          </span>
          <button aria-label="Increase quantity of ${item.product_title}" type="button" class="ucd-qty-btn" data-act="inc">＋</button>
        </div>

        ${bundleToggleHtml}
      </div>

      <div class="ucd-price">
        <button type="button" aria-label="Remove ${item.product_title}" class="ucd-remove1">
          ${TRASH_SVG}
        </button>
        <div>
          ${
            (Number(item.original_line_price) > Number(item.final_line_price))
              ? `<span class="ucd-money ucd-money--compare">${formatEUR(item.original_line_price)}</span>
                <span class="ucd-money ucd-money--sale">${formatEUR(item.final_line_price)}</span>`
              : `<span class="ucd-money">${formatEUR(item.final_line_price)}</span>`
          }
        </div>
      </div>

      ${bundleItemsHtml}
    </li>
  `;
}



  function bindEvents() {
    list.querySelectorAll('.ucd-line').forEach(li => {
      const key = li.dataset.key;

      li.querySelectorAll('.ucd-qty-btn').forEach(btn => {
        const act = btn.dataset.act;
        btn.addEventListener('click', () => {
          const numEl  = li.querySelector('.ucd-qty-num');
          const qtyNow = Number(numEl?.textContent || 1);
          const next   = act === 'inc' ? qtyNow + 1 : Math.max(0, qtyNow - 1);
          if (next === qtyNow) return;

          numEl.textContent = String(next);
          lineSetLoading(li, true);

          changeLine(key, next)
            .then(cart => render(cart))
            .catch(() => { numEl.textContent = String(qtyNow); })
            .finally(() => lineSetLoading(li, false));
        });
      });

      li.querySelector('.ucd-remove1')?.addEventListener('click', () => {
        lineSetLoading(li, true);
        changeLine(key, 0)
          .then(cart => render(cart))
          .finally(() => lineSetLoading(li, false));
      });
    });
  }

  // ✅ Event delegation for bundle toggles (works with full-width bundle layout)
  let bundleToggleBound = false;
  function bindBundleToggles() {
    if (bundleToggleBound) return;
    if (!list) return;

    bundleToggleBound = true;

    list.addEventListener('click', (e) => {
      const btn = e.target?.closest?.('.ucd-bundle-toggle');
      if (!btn) return;

      const line = btn.closest('.ucd-line');
      if (!line) return;

      const bundleWrap = line.querySelector('.ucd-bundle');
      const panel = bundleWrap?.querySelector('.ucd-bundle-items');
      const lineKey = bundleWrap?.dataset?.linekey;

      if (!panel || !lineKey) return;

      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const next = !expanded;

      btn.setAttribute('aria-expanded', next ? 'true' : 'false');
      panel.style.display = next ? 'block' : 'none';

      bundleOpenByKey[lineKey] = next;

      const count = Number(btn.dataset.count || 0);
      const label = btn.querySelector('.ucd-bundle-toggle__label');
      const chev  = btn.querySelector('.ucd-bundle-toggle__chev');

      if (label) label.textContent = next ? `Hide ${count} items` : `Show ${count} items`;
      if (chev) chev.textContent = next ? '▴' : '▾';
    });
  }


  function ensureGiftsMount() {
    let mount = document.getElementById('CartFreeGifts');
    if (!mount && list?.parentElement) {
      mount = document.createElement('div');
      mount.id = 'CartFreeGifts';
      mount.className = 'ucd-gifts-card';
      list.parentElement.insertBefore(mount, list);
    }
    return mount;
  }

  function giftGalleryItemHTML(item) {
    const img = item.image ? withWidthParam(item.image, 160) : '';
    return `
      <div class="ucd-gift-thumb" data-key="${item.key}">
        <button class="ucd-gift-remove" aria-label="Remove ${item.product_title}" title="Remove">×</button>
        ${img ? `<img src="${img}" alt="${item.product_title}">` : ``}
      </div>
    `;
  }

  function giftPillHTML(item) {
    const title = item.product_title || 'Gift';
    return `<span class="gift-pill" data-key="${item.key}">${title}</span>`;
  }

  function renderGiftsBlock(gifts) {
    const mount = ensureGiftsMount();
    if (!mount) return;
    if (!gifts.length) { mount.innerHTML = ''; return; }

    const gallery = gifts.map(giftGalleryItemHTML).join('');
    const pills   = gifts.map(giftPillHTML).join('');

    mount.innerHTML = `
      <div class="ucd-gifts-heading">FREE GIFTS</div>
      <div class="ucd-gifts-gallery">${gallery}</div>
      <div class="ucd-gifts-list">${pills}</div>
    `;

    mount.querySelectorAll('.ucd-gift-remove').forEach(btn => {
      const thumb = btn.closest('.ucd-gift-thumb');
      const key   = thumb?.dataset.key;
      if (!key) return;
      btn.addEventListener('click', async () => {
        mount.classList.add('is-loading');
        try {
          // Find the gift item to get its variant ID before removing
          const giftItem = gifts.find(g => g.key === key);
          const variantGid = giftItem?.id || '';
          const numericVid = Number(variantGid.split('/').pop());

          await changeLine(key, 0);

          // Store in ucd_suppressed_gift_variants (numeric variant IDs)
          try {
            const store = JSON.parse(sessionStorage.getItem('ucd_suppressed_gift_variants') || '[]');
            if (Number.isFinite(numericVid) && !store.includes(numericVid)) {
              store.push(numericVid);
            }
            sessionStorage.setItem('ucd_suppressed_gift_variants', JSON.stringify(store));
          } catch(e){}

          fetchCart().then(render);
        } finally {
          mount.classList.remove('is-loading');
        }
      });
    });
  }

  // === Sig check (unchanged) ===
  let lastSig = '';
  function signature(cart) {
    const itemsSig = (cart.items || [])
      .map(i => `${i.key}:${i.quantity}:${i.original_line_price}:${i.final_line_price}:${i.isBundle ? 'b' : 'n'}`)
      .join('|');
    return `${itemsSig}@${cart.total_price}`;
  }

  function render(cart) {
    if (!list) return;

    const sig = signature(cart);
    if (sig === lastSig) {
      if (subtotalEl) {
  const before = Number(cart.original_total_price) || 0;
  const after  = Number(cart.total_price) || 0;

  subtotalEl.innerHTML =
    (before > after)
      ? `<span class="ucd-money ucd-money--compare">${formatEUR(before)}</span>
         <span class="ucd-money ucd-money--sale">${formatEUR(after)}</span>`
      : `<span class="ucd-money">${formatEUR(after)}</span>`;
}

      return;
    }
    lastSig = sig;

    const items = cart.items || [];
    if (!items.length) {
      renderGiftsBlock([]);
      list.innerHTML = `
        <div class="empty-cart-container">
          <div class="empty-cart-image"><img src="https://cdn.shopify.com/s/files/1/0276/8430/7018/files/empty_cart.png?v=1750336414" alt="Empty Cart Icon"></div>
          <div class="empty-cart-title">Je winkelwagen is leeg.</div>
          <a href="/collections/all" class="shop-button">Verder winkelen</a>
        </div>`;
    } else {
      const normal = [];
      const gifts  = [];
      for (const it of items) {
        const isGift = it.properties && it.properties._auto_gift === 'true';
        (isGift ? gifts : normal).push(it);
      }
      renderGiftsBlock(gifts);
      list.innerHTML = normal.map(lineItemHTML).join('');
      bindEvents();
      bindBundleToggles();
    }

    if (subtotalEl) {
  const before = Number(cart.original_total_price) || 0;
  const after  = Number(cart.total_price) || 0;

  subtotalEl.innerHTML =
    (before > after)
      ? `<span class="ucd-money ucd-money--compare">${formatEUR(before)}</span>
         <span class="ucd-money ucd-money--sale">${formatEUR(after)}</span>`
      : `<span class="ucd-money">${formatEUR(after)}</span>`;
}

  }

  // === Debounce refresh (unchanged) ===
  let t;
  function schedule() {
    clearTimeout(t);
    t = setTimeout(() => {
      fetchCart().then(render).catch(err => {
        log('fetch error', err);
        if (list) list.innerHTML = `<li class="ucd-empty">Kan cart niet laden.</li>`;
      });
    }, 120);
  }

  function lineSetLoading(li, on) {
    if (!li) return;
    li.classList.toggle('is-loading', !!on);
    let spin = li.querySelector('.ucd-line-spinner');
    if (!spin) {
      spin = document.createElement('span');
      spin.className = 'ucd-line-spinner ucd-spinner';
      spin.setAttribute('aria-hidden', 'true');
      li.appendChild(spin);
    }
    spin.style.display = on ? 'inline-block' : 'none';
    li.querySelectorAll('.ucd-qty-btn, .ucd-remove').forEach(el => {
      el.disabled = !!on;
      el.setAttribute('aria-disabled', on ? 'true' : 'false');
    });
  }

  function initOnce() { schedule(); }

  document.addEventListener('DOMContentLoaded', initOnce);
  document.addEventListener('pb:cart:updated', e => render(normalizeCart(e.detail.cart)));
  document.addEventListener('cart:open', schedule);
})();
